import {
  DEFAULT_WIDTH,
  DEFAULT_HEIGHT,
} from '../aha_editor_field_v2/plugins/EmbeddedWhiteboard/constants';

export default function replaceLinksByContainers() {
  const whiteboardLinks = document.querySelectorAll('a[href*="/whiteboards/"]');

  whiteboardLinks.forEach(link => {
    const [path, params] = (link as HTMLAnchorElement).href.split('?');

    const idMatch = path.match(/\/whiteboards\/(\d+)$/);
    if (idMatch && idMatch[1]) {
      const whiteboardId = idMatch[1];
      const parsedParams = new URLSearchParams(params ?? '');

      const width = parseInt(
        parsedParams.get('width') ?? DEFAULT_WIDTH.toString(),
        10
      );
      const height = parseInt(
        parsedParams.get('height') ?? DEFAULT_HEIGHT.toString(),
        10
      );

      const div = document.createElement('div');
      div.style.width = `${width}px`;
      div.style.height = `${height}px`;
      div.style.maxWidth = '100%';
      div.setAttribute('data-whiteboard-id', whiteboardId);
      link.parentNode?.replaceChild(div, link);
    }
  });
}
